<template>
  <b-container id="app" class="" :class="{ notAuth: !isAuthenticated }">
    <router-view class="content"/>
   <b-modal
      v-if="isLoading"
      :visible="isLoading"
      centered
      :hide-footer="true"
      :hide-header="true"
      :hide-header-close="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
      <div class="precarga">
        <b-spinner class="mx-2"></b-spinner>
        Cargando información...
      </div>
    </b-modal>
  </b-container>
</template>

<script>
// @ is an alias to /src
import auth from "@/store/authentication.js";

export default {
  name: "App",
  components: {
  },
  created() {
    this.isAuthenticated = auth.state.authenticated;
  },
  data() {
    return {
      "isAuthenticated": null
    }
  },
  computed: {
    isLoading: {
      get: function () {
        return (
          this.$store.getters["packfrontal/isLoading"]
        );
      },
      set: function () {
      },
    },
  },
};
</script>

<style lang="scss">
// Import custom SASS variable overrides, or alternatively
// define your variable overrides here instead
@import "sass/_variables.scss";

// Import Bootstrap and BootstrapVue source SCSS files
@import "~bootstrap/scss/bootstrap.scss";
@import "~bootstrap-vue/src/index.scss";

$fa-font-path: "~@fortawesome/fontawesome-free-webfonts/webfonts";
@import "~@fortawesome/fontawesome-free-webfonts/scss/fontawesome.scss";
@import "~@fortawesome/fontawesome-free-webfonts/scss/fa-solid.scss";
@import "~@fortawesome/fontawesome-free-webfonts/scss/fa-regular.scss";
@import "~@fortawesome/fontawesome-free-webfonts/scss/fa-brands.scss";

#mainRow {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue